module.exports = __webpack_public_path__ + "static/media/Rv_logo.f07bd8ce.svg";